import { RowMiddle } from 'layout/Components/Row'
import { useState } from 'react'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import colors from 'theme/ui/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import CircleLoader from 'UIKit/Loader/CircleLoader'
import TransText from 'UIKit/Text/TransText'
import ViewModeInMobile from './ViewModeControl/ViewModeInMobile'

type ActionModalProps = {
  viewed: boolean
  handleToggle: (value: boolean) => void
  isUnread: boolean
  handleMarkAllAsRead: () => void
}

const ActionModal: React.FC<ModalProps<ActionModalProps>> = ({
  data: { handleToggle, isUnread, viewed, handleMarkAllAsRead },
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const onMarkAllAsRead = () => {
    if (!viewed) {
      handleMarkAllAsRead()
    }
    setIsLoading(true)

    setTimeout(() => {
      setIsLoading(false)
    }, 1200)
  }

  return (
    <AlchemyModal colorTheme={ModalColorTheme.Darkblue}>
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} />
      <ModalBody>
        <StyledSection>
          <ViewModeInMobile isUnread={isUnread} onValueChanged={handleToggle} width="100%" />
        </StyledSection>

        <StyledSection onClick={onMarkAllAsRead} mt="12px" justifyContent="space-between" mb="40px">
          <TransText fontSize="14px" fontWeight={500} color="text_link_secondary">
            Mark all as read
          </TransText>
          {isLoading && (
            <Box>
              <CircleLoader />
            </Box>
          )}
        </StyledSection>
      </ModalBody>
    </AlchemyModal>
  )
}

const StyledSection = styled(RowMiddle)`
  padding: 12px;
  height: 44px;
  background: ${colors.card_primary};
  border-radius: 12px;

  &:hover {
    cursor: pointer;
    background: ${colors.card_primary_active};
  }
`

export default ActionModal
